import { Spinner as ChakraSpinner } from '@chakra-ui/react';
import { forwardRef } from 'react';

type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';
type SpinnerTone = 'current' | 'action' | 'muted' | 'inverse';

const sizeMap: Record<SpinnerSize, string> = { xs: '3.5', sm: '4', md: '5', lg: '8' };
const toneMap: Record<SpinnerTone, string> = {
  current: 'currentColor',
  action: 'action.primary',
  muted: 'text.muted',
  inverse: 'text.inverse',
};

export interface SpinnerProps {
  size?: SpinnerSize;
  tone?: SpinnerTone;
  /** Accessible label announced to screen readers (defaults to "Loading"). */
  label?: string;
  className?: string;
}

/** An indeterminate activity indicator. */
export const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(function Spinner(
  { size = 'md', tone = 'action', label = 'Loading', className },
  ref,
) {
  return (
    <ChakraSpinner
      ref={ref}
      className={className}
      boxSize={sizeMap[size]}
      borderWidth="2px"
      color={toneMap[tone]}
      css={{ '--spinner-track-color': 'colors.border.subtle' }}
      aria-label={label}
    />
  );
});
